module.exports = __webpack_public_path__ + "img/sticker05.b1eeaa09.png";